import { z } from 'zod'

import api from '@/utils/api/api'

type RequestOptions = {
  signal?: AbortSignal
}

type CardfileInfoResponse = { info: string }

const counterSchema = z.object({ quantity: z.number().nullish() }).nullish()

export const cardfileDataSchema = z.object({
  name: z.string().nullish(),
  short_name: z.string().nullish(),
  egr_name: z.string().nullish(),
  egr_short_name: z.string().nullish(),
  egr_status_code: z.number().nullish(),
  egr_status_name: z.string().nullish(),
  address: z.string().nullish(),
  egr_reg_date: z.string().nullish(),
  oked_primary_name: z.string().nullish(),
  oked_primary_code: z.string().nullish(),
  writ: z
    .object({ debtor: z.number().nullish(), creditor: z.number().nullish() })
    .nullish(),
  executory: z.object({ debtor: z.number().nullish() }).nullish(),
  imns_debtors: z.array(z.unknown()).nullish(),
  status_mns: z.string().nullish(),
  checks: z.array(z.unknown()).nullish(),
  trademarks: counterSchema,
  certs_of_conf: counterSchema,
})

export type CardfileData = z.infer<typeof cardfileDataSchema>

const cardfileEnvelopeSchema = z.object({ data: cardfileDataSchema })

export const parseCardfileInfo = (info: string): CardfileData =>
  cardfileEnvelopeSchema.parse(JSON.parse(info)).data

export const cardfileApi = {
  getInfo: async (vatNumber: string, options?: RequestOptions) => {
    const { data } = await api.get<CardfileInfoResponse>(
      `/cardfile/${vatNumber}`,
      { signal: options?.signal }
    )
    return parseCardfileInfo(data.info)
  },
}
